import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { propertySaveService } from '../../../services/propertySaveService'
import { propertiesService } from '../../../services/propertiesService'
import {
  PROPERTY_TYPE_BOOLEAN,
  PROPERTY_TYPE_NUMBER,
  PROPERTY_TYPE_SELECT,
  PROPERTY_TYPE_STRING,
} from '../../../constant'
import SelectWithoutTokens from '../../../shared/SelectWithoutTokens'
import PropertyItemValue from './PropertyItemValue'
import PropertyItemNumberUnits from './PropertyItemNumberUnits'

type SelectOption = {
  id: string
  name: string
}

const PropertyItemType = () => {
  const { i18n } = useTranslation()
  const [propertyType, setPropertyType] = useState(
    () => propertySaveService.getProperty().propertyType || '',
  )
  const [valuesCountIsChanged, setValuesCountIsChanged] = useState(false)

  const makePropertyTypesList = (): SelectOption[] => [
    {
      id: PROPERTY_TYPE_NUMBER,
      name: i18n.t(
        propertiesService.getPropertyTypei18nCode({
          propertyType: PROPERTY_TYPE_NUMBER,
        }),
      ),
    },
    {
      id: PROPERTY_TYPE_SELECT,
      name: i18n.t(
        propertiesService.getPropertyTypei18nCode({
          propertyType: PROPERTY_TYPE_SELECT,
        }),
      ),
    },
    {
      id: PROPERTY_TYPE_BOOLEAN,
      name: i18n.t(
        propertiesService.getPropertyTypei18nCode({
          propertyType: PROPERTY_TYPE_BOOLEAN,
        }),
      ),
    },
    {
      id: PROPERTY_TYPE_STRING,
      name: i18n.t(
        propertiesService.getPropertyTypei18nCode({
          propertyType: PROPERTY_TYPE_STRING,
        }),
      ),
    },
  ]

  const getPropertyTypeTitle = (type: string): string => {
    if (!type) {
      return ''
    }
    return i18n.t(propertiesService.getPropertyTypei18nCode({ propertyType: type }))
  }

  const changePropertyType = (property: SelectOption) => {
    setPropertyType(property.id)
    propertySaveService.updatePropertyValue('propertyType', property.id)
  }

  const changePropertyState = () => {
    setPropertyType(propertySaveService.getProperty().propertyType || '')
    setValuesCountIsChanged((prev) => !prev)
  }

  useEffect(() => {
    changePropertyState()
    propertySaveService.registerItemUpdateObserver(changePropertyState)
    return () =>
      propertySaveService.unRegisterItemUpdateObserver(changePropertyState)
  }, [])

  const selectValues = propertySaveService.getProperty().selectValues as
    | string[]
    | null
    | undefined

  return (
    <>
      <label
        className="block__text product__form-label"
        key={`${propertyType}label`}
      >
        <span className="product__form-label_text">
          {i18n.t('app.page.product.propertyItem.propertyType')}
        </span>
        <SelectWithoutTokens
          listOfOptions={makePropertyTypesList()}
          handleChangeValue={changePropertyType}
          titleValue={getPropertyTypeTitle(propertyType)}
        />
      </label>
      {propertyType === PROPERTY_TYPE_SELECT ? (
        selectValues ? (
          selectValues.map((it, index) => (
            <Fragment key={`${String(it)}${index}${valuesCountIsChanged}`}>
              <PropertyItemValue
                itemSaveService={propertySaveService}
                index={index}
              />
            </Fragment>
          ))
        ) : (
          <PropertyItemValue itemSaveService={propertySaveService} index={0} />
        )
      ) : null}
      {propertyType === PROPERTY_TYPE_NUMBER ? <PropertyItemNumberUnits /> : null}
    </>
  )
}

export default PropertyItemType
